import { BaseModel } from '../base-model';

export interface IPropertyListingModel {
    Id?: number;
    Reference?: string;
 }

export class PropertyListingModel extends BaseModel<IPropertyListingModel> implements IPropertyListingModel {
    Id?: number;
    Reference?: string;
    
    constructor(option?: IPropertyListingModel) {
        super(option);

    }
}